/**
 * Where the asset tree lives. Split out from `deck.ts` so `manifest.ts` can call it without the
 * atlas loaders importing the manifest back (`Assets.init` has to run before the first
 * `Assets.load`, so `deck.ts` does depend on `manifest.ts`).
 */
import { netBase } from '../../bridge/embedded';

/** `/assets` on the web, `/.proxy/assets` inside the Discord activity (§13). */
export function assetBase(): string {
  return `${netBase()}/assets`;
}
